import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const ChevronDown = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse, otherGenericStyle } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    style,
  });

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      // eslint-disable-next-line local-rules/no-svg-spread, react/jsx-props-no-spreading
      {...otherGenericStyle}
      width={widthToUse}
      height={heightToUse}
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.85545 8.66484C6.24598 8.27432 6.87914 8.27432 7.26967 8.66484L12.5626 13.9577L17.8555 8.66484C18.246 8.27432 18.8791 8.27432 19.2697 8.66484C19.6602 9.05537 19.6602 9.68853 19.2697 10.0791L13.2697 16.0791C12.8791 16.4696 12.246 16.4696 11.8555 16.0791L5.85545 10.0791C5.46493 9.68853 5.46493 9.05537 5.85545 8.66484Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};
